import { Pipe, PipeTransform } from '@angular/core';
import { Variable } from '@mtna/pojo-consumer-ts';
import { VariableSummary } from '@mtna/variable-service-core-ts';

import { RdsFilterUtil } from '../core/utils/filter-util';

@Pipe({
  name: 'rdsFilterTypeSubtitle',
})
export class FilterTypeSubtitlePipe implements PipeTransform {
  transform(variable: Variable | VariableSummary | undefined): string {
    const type = RdsFilterUtil.determineType(variable);
    // Title case the type and add the text ' Filter',
    // i.e. where type is CODE, it would be transformed to
    // 'Code Filter'
    let filterType = '';
    if (type) {
      filterType = type[0].toUpperCase() + type.substr(1).toLowerCase();
    }
    return !type ? '' : $localize`:|i.e. Code Filter or Numeric Filter:${filterType} Filter`;
  }
}
